import { getFormInvalidProperty, getFormDefinitionUpdateErrors, getFormFields, getFormType
// @ts-expect-error types missing
} from 'FormsUI/selectors/FormDefinition';
import { NonRemovableProperties } from 'forms-utils-lib/constants/Properties';
import { getFormFieldError as getFormFieldErrorUtil } from 'FormsUI/utils/FormFieldsUtils';
export const getFormFieldError = (state, formField) => {
  const invalidProperty = getFormInvalidProperty(state);
  const formDefinitionUpdateErrors = getFormDefinitionUpdateErrors(state);
  return getFormFieldErrorUtil({
    formField,
    invalidProperty,
    formDefinitionUpdateErrors
  });
};
export const getIsRemovableField = (state, formField) => {
  const formFields = getFormFields(state);
  const formType = getFormType(state);
  const nonRemovablePropertiesForFormType = NonRemovableProperties[formType] || [];
  const nonRemovablePropertiesForObject = nonRemovablePropertiesForFormType ? nonRemovablePropertiesForFormType[formField.objectTypeId] : [];
  const shouldBeNonRemovable = nonRemovablePropertiesForObject ? nonRemovablePropertiesForObject.includes(formField.name) : false;
  const isMoreThanOnce = formFields.filter(field => formField.name === field.name && formField.objectTypeId === field.objectTypeId).length > 1;
  return !shouldBeNonRemovable || isMoreThanOnce;
};